import { h } from 'preact'
import classNames from 'clsx'

import { getDisplayName } from '../../utils'

import styles from './index.module.scss'

const Boxed = (Component, displayName) => {
  const WrappedComponent = ({ className, padded, withBackground, ...props }) => (
    <Component
      {...props}
      className={buildBoxClassNames({
        className,
        padded,
        withBackground,
      })}
    />
  )

  WrappedComponent.displayName = displayName || `Boxed(${getDisplayName(Component)})`

  return WrappedComponent
}

export function buildBoxClassNames({ className, padded, withBackground }) {
  return classNames(
    className,
    styles['u-box'],
    {
      [styles['u-box--padded']]: padded,
      [styles['u-box--background']]: withBackground,
    },
  )
}

export default Boxed
